import * as icons from 'grommet-icons';
import { ChatMessage } from '@talon/web/lib/api';

export interface INotificationIconProps {
  notification: ChatMessage;
}

export const NotificationIcon = ({ notification }: INotificationIconProps) => {
  const { source_entity_name = '' } = notification;

  const iconMap: Record<string, React.JSX.Element> = {
    Advertiser: <icons.CircleInformation />,
    Allowance: <icons.Money />,
    ChatMessage: <icons.Chat />,
    Commercial: <icons.Video />,
    Conversation: <icons.ChatOption />,
    Costume: <icons.UserPolice />,
    Document: <icons.DocumentText />,
    DocumentEmbedding: <icons.DocumentConfig />,
    Edit: <icons.Edit />,
    EditReview: <icons.CircleInformation />,
    Estimate: <icons.Table />,
    Feature: <icons.Actions />,
    Fee: <icons.Money />,
    Group: <icons.Group />,
    Location: <icons.MapLocation />,
    Performer: <icons.Run />,
    PerformerContract: <icons.Contract />,
    PricingTier: <icons.Currency />,
    Project: <icons.CircleInformation />,
    Prop: <icons.Bike />,
    Right: <icons.Certificate />,
    Role: <icons.User />,
    RoleActivity: <icons.User />,
    RoleGroup: <icons.Group />,
    Script: <icons.Script />,
    Session: <icons.Calendar />,
    SessionActivity: <icons.Yoga />,
    SessionEstimate: <icons.Table />,
    SessionEstimateItem: <icons.CircleInformation />,
    SubscriptionPlan: <icons.CreditCard />,
    Tags: <icons.CircleInformation />,
    TimeLog: <icons.Clock />,
    Usage: <icons.DocumentVideo />,
    UsageEstimate: <icons.Table />,
    UsageEstimateItem: <icons.CircleInformation />,
    User: <icons.User />,
    // Talent manager notices (the API's TalentManagerNotice)
    tmProfile: <icons.UserExpert />,
    tmEngagement: <icons.Briefcase />,
    tmEarnings: <icons.Money />,
    tmApplication: <icons.UserAdd />,
    tmProjectTime: <icons.Clock />,
  };

  return iconMap[source_entity_name] ?? <icons.CircleInformation />;
};
